// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid-view.section[data-v-06b791da] {\n  padding: 10px 20px;\n}\n", ""]);
// Exports
module.exports = exports;
